// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__zlVnJ","Horizontal":"Navigation_Horizontal__Xhis7"};